import { OutgoingMessage } from 'types/messages/outgoing';
import * as PostMessage from './postmessage';

const state: {
  isSRCiWindowRef: boolean;
  type: 'iframe' | 'popup';
  popupInterval?: number;
  window: Window | null;
} | null = null;

export async function sendToCheckout(message: OutgoingMessage) {
  if (state?.window) {
    PostMessage.send(state.window, message);
  }
}
//START GENAI@COPILOT

/*eslint-disable-next-line*/
export const generateCreateIntentRequestStr = (rawInput: any) => {
  const originalMerchantConfig = window.VSB_GLOBALS.merchantConfig.merchantConfig;

  // Create a new object to avoid mutating the read-only original
  //START GENAI@CHATGPT4
  const merchantConfigResponse = {
    ...originalMerchantConfig,
    shippingConstraints: {
      ...originalMerchantConfig.shippingConstraints,
      collectShipping: rawInput?.dpaTransactionOptions?.dpaShippingPreference === 'FULL'
    },
    //END GENAI@CHATGPT4
    //START GENAI@COPILOT
    datalevel: rawInput?.payloadTypeIndicatorCheckout
    //END GENAI@COPILOT
  };

  return JSON.stringify({
    channel: 'Web',
    eventSource: 'LightboxTW',
    // @ts-ignore
    merchantConfig: merchantConfigResponse,
    // @ts-ignore
    srciClientId: window.VSB_GLOBALS.merchantConfig.merchantConfig.clientId,
    srciProfile: true
  });
};
